<div style="width: 100%; max-width: 800px; margin: auto;">

  <mat-card style="text-align: center;">
    <img style='width: 200px; margin: 20px auto 20px auto;' src='assets/images/geral/selo_sbccv.png'>
    <div *ngIf='invite'>
      <p>
        Olá!
        <br> <br>
        <span style='opacity:.7;'><b>{{invite.member_name}}</b></span>
      </p>
      <p>
        A SBCCV te convida a participar do
      </p>
      <p>
        <span style='font-size: 1.2em; opacity:.7;'><b>{{invite.event_name}}</b></span>
      </p>
    </div>
  </mat-card>


  <div *ngIf='invite'>
    <div *ngFor="let appointment of invite.agenda">

      <mat-card>

        <div class="tarja">
          <div style="padding-top: 5px; font-weight: bold; color: rgba(0,0,0, .6);">
            <span>{{appointment.role_name}}</span>
            <span *ngIf="appointment.level=='t'"> no tópico</span>
            <span *ngIf="appointment.level=='a'"> na atividade</span>
          </div>
          <!--
          <mat-checkbox [(ngModel)]="appointment.acceptInvite" color='primary'
            *ngIf="invite.date_sent && !invite.date_response">
            Confirmar
          </mat-checkbox>
          -->
          <div *ngIf="invite.date_sent && invite.date_response">
            <div *ngIf="appointment.acceptInvite">
              <img style='width: 10px;' src="assets/images/status/img_green.png">
            </div>
            <div *ngIf="!appointment.acceptInvite">
              <img style='width: 10px;' src="assets/images/status/img_red.png">
            </div>
          </div>
        </div>

        <ul style="margin: 0; padding-left: 20px; ">
          <li>
           <b>{{appointment.day_date_string}}</b>
          </li>
          <li *ngIf="appointment.depto_name">
            <div class='line-display'>Departamento: </div>
            {{appointment.depto_name}}
          </li>
          <li>
            <div class='line-display'>Atividade: </div>
            {{appointment.activity_startTime}} -
            {{appointment.activity_name}}
          </li>

          <div *ngIf="appointment.level=='t'">
            <li>
              <div class='line-display'>Tópico: </div>
              {{appointment.topic_startTime}} -
              {{appointment.topic_name}}
            </li>
            <li>
              <div class='line-display'>Duração: </div>
              {{appointment.topic_duration}} minutos
            </li>
            <li>
              <div>Equipe do Tópico</div>
              <ul *ngFor="let st of appointment.topicStaff">
                <li>
                  <div *ngIf="invite.member_name == st.member_name" style="color:rgb(8, 8, 189);">{{st.role_name}} -
                    {{st.member_name}}</div>
                  <div *ngIf="invite.member_name != st.member_name">{{st.role_name}} - {{st.member_name}}</div>
                </li>
              </ul>
            </li>

          </div>

          <div *ngIf="appointment.level=='a'">

            <li>
              <div>Equipe da atividade</div>
              <ul *ngFor="let st of appointment.activityStaff">
                <li>
                  <div *ngIf="invite.member_name == st.member_name" style="color:rgb(8, 8, 189);">{{st.role_name}} -
                    {{st.member_name}}</div>
                  <div *ngIf="invite.member_name != st.member_name">{{st.role_name}} - {{st.member_name}}</div>
                </li>
              </ul>
            </li>
            <li>
              <div>Tópico(s)</div>
              <ul *ngFor="let ac of appointment.activityTopics">
                <li>
                  <div>{{ac.topic_startTime}} - {{ac.topic_name}}</div>
                </li>
              </ul>
            </li>
          </div>
        </ul>

        <mat-radio-group [(ngModel)]='appointment.acceptInvite' aria-label="Selecione"
          *ngIf="invite.date_sent && !invite.date_response"
          style="width: 100%; display: flex; flex-direction: row; justify-content: space-between; margin-top: 10px; ">

          <div
            style="width: 50%; display: flex; justify-content: center;  background-color: rgb(193, 208, 211); padding: 8px; border-top-left-radius: 5px; border-bottom-left-radius: 5px; ">
            <mat-radio-button [value]="true" color='primary'>Aceito</mat-radio-button>
          </div>

          <div
            style="width: 50%; display: flex; justify-content: center;  background-color: rgb(222, 175, 172); padding: 8px; border-top-right-radius: 5px; border-bottom-right-radius: 5px;">
            <mat-radio-button [value]="false">Não aceito</mat-radio-button>
          </div>

        </mat-radio-group>

      </mat-card>

    </div>
  </div>

  <mat-card *ngIf='invite && invite.date_response'>
    <div *ngIf='invite.accept' style="text-align: center; font-size: 1.2em;">
      <b>Esta solicitação foi aceita.</b>
    </div>
    <div *ngIf='!invite.accept' style="text-align: center; font-size: 1.2em;">
      <b>Esta solicitação foi recusada, total ou parcialmente.</b>
    </div>
  </mat-card>

  <mat-card *ngIf='invite && !invite.date_response'>
    <form style='width: 100%; max-width: 550px; margin: auto;' name="entityForm" [formGroup]='entityForm'
      autocomplete="off">
      <label>Caso necessite, deixe seu comentário.</label>

      <textarea style='width: 100%; max-width: 600px; height:60px; font-size:16px;' matInput
        [formControl]="entityForm.controls.obs" placeholder="Comentários adicionais." autocomplete="off">
            </textarea>
    </form>
  </mat-card>

  <mat-card *ngIf='invite && !invite.date_response'>

    <div class="tarja-2">
      Divulgação de dados pessoais.
    </div>
    <div style="width: 95%; max-width: 550px; text-align: justify; margin: auto;">
      <p>
        Autorizo a divulgação de meu e-mail aos expositores participantes do evento.
      </p>
      <p>
        Estou ciente de que meus dados pessoais fornecidos serão utilizados apenas para viabilizar acesso ao
        evento, não havendo nenhuma divulgação a terceiros.
      </p>
      <p>
        Autorizo a utilização de minha foto e currículo apenas para divulgação de participação no evento <span
          style='opacity:.7;'><b>{{invite.event_name}}</b></span>.
      </p>
    </div>

  </mat-card>

  <mat-card *ngIf='invite && !invite.date_response'>

    <div class="tarja-2">
      Publicação dos materiais de apoio.
    </div>
    <div style="width: 95%; max-width: 550px; text-align: justify; margin: auto;">
      <p>
        Com esta autorização a SBCCV fica livre para publicar em sua plataforma digital os materiais de apoio utilizados
        em minhas participações de acordo com a estratégia de divulgação definida para o evento <span
          style='opacity:.7;'><b>{{invite.event_name}}</b></span>.
      </p>
    </div>

    <mat-radio-group [(ngModel)]='publishSlides' aria-label="Selecione"
      *ngIf="invite.date_sent && !invite.date_response"
      style="width: 100%; display: flex; flex-direction: row; justify-content: space-between; margin-top: 10px; ">

      <div
        style="width: 50%; display: flex; justify-content: center;  background-color: rgb(193, 208, 211); padding: 8px; border-top-left-radius: 5px; border-bottom-left-radius: 5px; ">
        <mat-radio-button [value]="true" color='primary'>Autorizo</mat-radio-button>
      </div>

      <div
        style="width: 50%; display: flex; justify-content: center;  background-color: rgb(222, 175, 172); padding: 8px; border-top-right-radius: 5px; border-bottom-right-radius: 5px;">
        <mat-radio-button [value]="false">Não autorizo</mat-radio-button>
      </div>

    </mat-radio-group>

  </mat-card>

  <mat-card *ngIf='invite && !invite.date_response'>
    <div style='width: 100%; max-width: 550px; text-align: center; margin: auto;'>
      <button class='btn-invite' mat-button (click)='updateAccept(entityForm.controls.obs.value)'>
       <span style="color:white;"> Registrar as respostas</span>
      </button>
    </div>
  </mat-card>






  <br>
  <br>
  <br>

</div>